import { Card, Table } from "@arco-design/web-react";
import { SOPickOrderAdd } from "./so-pick-order-add";
import { SOPickOrderInfo } from "./so-pick-order-info";
import { SOPickOrderEdit } from "./so-pick-order-edit";
import { SOPickOrderInfoPrint } from "./so-pick-order-print";
import { Link } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { SOPOAPI } from "@/apis/sales";
import { SOPOStatusDef } from "@/enums/sales";
import { EnumLabel } from "@/components/Enum";
import SaleOrderLink from "@/components/SaleOrderLink";

export const SOPickOrder = () => {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    const getList = useCallback(async () => {
        const values = await SOPOAPI.query(page);
        setData(values.records);
        setTotal(values.total);
    }, [page]);

    useEffect(() => {
        getList();
    }, [getList]);

    return (
        <Card title="Pick Order">
            <Table rowKey="id" columns={[
                {
                    title: "Pick Order#", dataIndex: "pickOrderNo",
                    render: (col, record) =>
                        <Link to={"/workspace/sales/so-pick-order/" + record.id}>{record.pickOrderNo}</Link>
                },
                { title: "Status", dataIndex: "status", render: (col, record) => <EnumLabel enumObj={SOPOStatusDef} value={record.status} /> },
                { title: "Customer Name", dataIndex: "customerName" },
                { title: "Fulfillment#", dataIndex: "fulfillment.soFulfillmentNo" },
                {
                    title: "SO#",
                    render: (col, record) =>
                        <SaleOrderLink soId={record.soId}>{record.soNo}</SaleOrderLink>
                },
                { title: "SO Due Date", dataIndex: "soDueDate" },
                { title: "SO Creation Date", dataIndex: "soCreateDate" },
            ]} data={data} pagination={{ total, current: page, pageSize: 20 }} onChange={(pagination) => setPage(pagination.current)} />
        </Card>
    )
}

SOPickOrder.Add = SOPickOrderAdd;
SOPickOrder.Info = SOPickOrderInfo;
SOPickOrder.Edit = SOPickOrderEdit;
SOPickOrder.Print = SOPickOrderInfoPrint;
